import ISpinData, {
    IOverlayData,
    ISpinificationData,
    IWinData,
} from "../../../core/src/server/data/ISpinData";
import AbstractBulkDataParser from "../../../core/src/server/parsers/AbstractBulkDataParser";
import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import {
    IVendorSpinData,
    IVendorWinData,
    IVendorLineData,
    IVendorBonusData,
} from "../../model/IVendorSpinData";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";
import JackpotsModel from "../../model/JackpotsModel";
import DebugModel from "../../../core/src/model/DebugModel";
import { BonusName } from "../data/BonusName";
import CommManager from "../../../core/src/controllers/CommManager";
import RoundType from '../../../core/src/const/RoundType';
import App from "../../../core/src/App";
import Configs from "../../vendorConfigs/Configs";
export default class SpinDataParser extends AbstractBulkDataParser<ISpinData> {
    protected processedData: ISpinData[];
    protected accumulatedWin: number = 0;
    protected totalFreeSpinsCount = 0;
    protected currentFreeSpinsCount = 0;
    //overrite in game specific for different amount of FS
    protected gameSpecificFreespinTotalPerDrop: number = 15;
    protected validateData(data: any): boolean {
        return (
            data?.data?.gameData?.view || data?.data?.lastSessionData?.betResult
        );
    }

    protected processData(data): ISpinData[] | ISpinData {
        ConsoleUtil.warn("SPIN DATA", data);
        if (data) {
            if (DebugModel.fakeJackpot) {
                JackpotsModel.winAmount = DebugModel.fakeJackpot.amount;
                JackpotsModel.jackpotWonName = DebugModel.fakeJackpot.name;
                DebugModel.cleanUp();
            } else {
                if (JackpotsModel.playForJackpot === true && data.data.jackpot?.won) {
                    JackpotsModel.winAmount = Number(data.data.jackpot.won.amount);
                    JackpotsModel.jackpotWonName = data.data.jackpot.won.name;
                }
            }

            this.accumulatedWin = 0;
            this.totalFreeSpinsCount = 0;
            this.currentFreeSpinsCount = 0;
        }

        const spinData: IVendorSpinData =
            data.data.gameData ||
            data.data.lastSessionData.betResult.playData.gameData;
        let result: ISpinData = this.parseSlotObject(spinData, undefined, undefined, undefined, RoundType.NORMAL);
        let secondary: ISpinData = this.parseSlotObject(spinData, undefined, undefined, undefined, RoundType.NORMAL);


        // Reset the main spin free spins counts.
        result.freespinsNum = 0;
        result.freespinsWon = 0;
        result.totalFreeSpins = 0;

        // Starting with the total free spins count, then we subtract the retriggers.
        let initialFreeSpinsCount = this.gameSpecificFreespinTotalPerDrop;
        spinData?.bonusInfo?.forEach((bonusData, index) => {
            if (bonusData.bonusName === 'AvalancheResult') {
                bonusData.bonusInfo.forEach((nestedBonus, nbIndex) => {
                    if (nestedBonus?.freeSpinList && nbIndex === 1) {
                        // initialFreeSpinsCount = nestedBonus?.freeSpinList.length;
                    }
                    if (nestedBonus?.freeSpinList) {
                        // initialFreeSpinsCount -= nestedBonus.countFreeSpins;
                    }

                });
            }

            if (bonusData?.freeSpinList?.length) {
                bonusData.freeSpinList.forEach(spin => {
                    spin?.bonusInfo?.forEach(bonus => {
                        if (bonus.bonusName == BonusName.BonusFreeSpins && Utils.isNumeric(bonus.countFreeSpins)) {
                            // initialFreeSpinsCount -= bonus.countFreeSpins;
                        }
                    });
                });
            }
        });
        // freespin selection screen
        spinData?.bonusInfo?.forEach((bonusData) => {
            if (bonusData.bonusName == BonusName.FreeSpinChoice && !result?.isFree) {
                result.freespinSelectScreen = true;
            } else {
                result.freespinSelectScreen = false;
            }
        });
        let results: ISpinData[] = [];
        results.push(result);

        spinData?.bonusInfo?.forEach((bonusData) => {
            if (bonusData.bonusName === 'AvalancheResult') {
                bonusData.bonusInfo.forEach((nestedBonus, nbIndex) => {
                    if (nestedBonus?.freeSpinList) {
                        this.addRetriggerData(
                            nestedBonus,
                            result,
                            results,
                            initialFreeSpinsCount
                        );
                    }
                });
            }
            if (bonusData?.freeSpinList?.length) {
                // We have free spins awarded
                this.addRetriggerData(
                    bonusData,
                    result,
                    results,
                    initialFreeSpinsCount
                );
            } else if (bonusData?.reSpinsList) {
                // Adding the non fs respins
                this.addRespinData([bonusData], result, results, false);
            }
        });

        this.validateResults(results, spinData);
        if (!result.initial && App.config.isCascadeGame) {
            secondary.cascades.forEach((cascade) => {
                if (cascade.cascadeFreespinCutoffIndex) {
                    secondary.cascades.splice(0, cascade.cascadeFreespinCutoffIndex)
                    // 0 out freespins so its not an endless loop
                    secondary.freespinsNum = 0;
                    secondary.freespinsWon = 0;
                    //0 out data to make sure end cascade doesnt have winline
                    secondary.winsData = []
                    results.push(secondary);
                }
            })

        } else if (result.initial && App.config.isCascadeGame) {
            secondary.freespinsNum = 0;
            secondary.freespinsWon = 0;
            results.push(secondary);
        }
        return results;
    }

    protected validateResults(results: ISpinData[], spinData: IVendorSpinData): void {
        // Computing the free spins win amounts and count.
        let freeWonAmount = 0;
        let freeWonCount = 0;
        results.forEach(res => {
            if (res.isFree) {
                freeWonAmount += res.winAmount;
            }

            if (Utils.isNumeric(res.freespinsWon) && res.freespinsWon > 0) {
                freeWonCount += res.freespinsWon;
            }
        })

        // Define some number precision tolerance, needed for the comparisons
        const precision = 1e-4;

        // Check the free spins money
        if (!Utils.almostEquals(freeWonAmount, spinData.spinStats.freeWon, precision)) {
            const errorMessage = `FATAL: Free spin wins are not computed properly! Expected: ${spinData.spinStats.freeWon}, Computed: ${freeWonAmount}`;
            this.onError(spinData, errorMessage);
        }

        // Check the free spins (won) count, including the retriggered
        if (!Utils.almostEquals(freeWonCount, spinData.spinStats.freeSpinCount, precision)) {
            const errorMessage = `FATAL: Free spin won count is not computed properly! Expected: ${spinData.spinStats.freeSpinCount}, Computed: ${freeWonCount}`;
            this.onError(spinData, errorMessage);
        }

        // Ensure the accumulated wins are properly computed
        if (!Utils.almostEquals(this.accumulatedWin, spinData.spinStats.totalWon, precision)) {
            const errorMessage = `FATAL: accumulatedWin differs the totalWon! Expected: ${spinData.spinStats.totalWon}, Computed: ${this.accumulatedWin}`;
            this.onError(spinData, errorMessage);
        } else {
            results.reduce((previous, current, index, array) => {
                if (!Utils.almostEquals(previous.accumulatedWin, current.accumulatedWin - current.winAmount)) {
                    const errorMessage = `FATAL: accumulatedWin is not properly accumulated! Index: ${index}, Array: ${array}`;
                    this.onError(spinData, errorMessage);
                }

                return current;
            })
        }
    }

    protected getScatterWin(spinData: IVendorSpinData) {
        const scatterWin = spinData?.bonusInfo?.find(bonus => bonus.bonusName == BonusName.Scatter)?.creditsWon || 0;
        return scatterWin;
    }

    protected getRespinWin(spinData: IVendorSpinData) {
        const respinWin = spinData?.bonusInfo?.find(bonus => bonus.bonusName == BonusName.BonusReSpins)?.creditsWon || 0;
        return respinWin;
    }

    protected onError(data: IVendorSpinData, errorMessage: string) {
        console.error(errorMessage, data);
        Utils.sendCustomError(errorMessage, data, CommManager.getComm());
        throw new Error(errorMessage);
    }

    /**
     * Pushes the freespins and retriggered freespins to the existing results.
     *
     * @private
     * @param {any[]} bonusData bonus data
     * @param {*} result The current result
     * @param {*} results Current results
     * @memberof SpinDataParser
     */
    protected addRetriggerData(bonusData: any, result: ISpinData, results: ISpinData[], freeSpinCount: number): void {
        if (!bonusData) {
            return;
        }

        if (!bonusData.freeSpinList) {
            return;
        }

        if (!Utils.isNumeric(freeSpinCount)) {
            throw new Error("Non numeric freeSpinCount passed!");
        }

        if (freeSpinCount < 0) {
            throw new Error("Negative freeSpinCount passed!");
        }

        this.currentFreeSpinsCount += freeSpinCount;
        this.totalFreeSpinsCount += freeSpinCount;
        result.freespinsWon = freeSpinCount;

        if (bonusData.freeSpinList.length == 0) {
            // This is a valid case for retrigger.
            // In such case the freeSpinCount param is passed,
            // so there is no actual need for the freeSpinList object.
            return;
        }

        if (this.currentFreeSpinsCount < 0 || this.totalFreeSpinsCount < 0) {
            throw new Error("Negative Free Spins counter detected (place 1)!");
        }

        result.freespinsNum = this.currentFreeSpinsCount;
        result.totalFreeSpins = this.totalFreeSpinsCount;

        const addFreeSpinData = (fsData) => {
            let fSpin: ISpinData = undefined;
            if (App.config.isCascadeGame) {
                fSpin = this.cascadeHandle(
                    fsData,
                    true,
                    result.winAmount,
                    Utils.deepClone(results),
                    RoundType.FREE_SPIN
                );
            } else {
                fSpin = this.parseSlotObject(
                    fsData,
                    true,
                    result.winAmount,
                    Utils.deepClone(results),
                    RoundType.FREE_SPIN
                );
            }


            this.currentFreeSpinsCount--;
            fSpin.freespinsWon = 0;
            if (fSpin.totalFreeSpins > this.totalFreeSpinsCount) {
                this.currentFreeSpinsCount += fSpin.freespinsNum;
                this.totalFreeSpinsCount = fSpin.totalFreeSpins;
            }


            fSpin.freespinsNum = this.currentFreeSpinsCount;
            fSpin.totalFreeSpins = this.totalFreeSpinsCount;
            if (this.currentFreeSpinsCount < 0 || this.totalFreeSpinsCount < 0) {
                throw new Error("Negative Free Spins counter detected (place 2)!");
            }

            results.push(fSpin);
            fsData?.bonusInfo?.forEach((data) => {
                this.addRetriggerData(data, fSpin, results, data?.countFreeSpins);
            });
            // Adding the respins, nested in a freespins list.
            this.addRespinData(fsData.bonusInfo, result, results, true);
        }

        bonusData.freeSpinList.forEach((fsData) => {
            if (Array.isArray(fsData)) {
                fsData.forEach(data => {
                    addFreeSpinData(data);
                })
            } else {
                addFreeSpinData(fsData);
            }
        });
    }

    /**
     * Pushes the respins to the existing results.
     *
     * @private
     * @param {any[]} bonuses Array of bonus data
     * @param {*} result The current result
     * @param {*} results Current results
     * @memberof SpinDataParser
     */
    protected addRespinData(bonuses: any[], result: ISpinData, results: ISpinData[], isSpinFree: boolean): void {
        bonuses.forEach((bonus) => {
            if (bonus?.reSpinsList?.length) {
                result.reSpinData = {
                    awarded: bonus.reSpinsCount,
                    remaining: bonus.reSpinsCount,
                    win: bonus.creditsWon || 0,
                    reTriggered: 0,
                    reSpinsList: bonus.reSpinsList
                }

                if (bonus.reSpinsCount < 0) {
                    throw new Error("Negative bonus.reSpinsCount detected!");
                }

                bonus.reSpinsList.forEach((rsData, index) => {
                    let reSpin = this.parseSlotObject(
                        rsData,
                        isSpinFree,
                        result.winAmount,
                        Utils.deepClone(results),
                        RoundType.RE_SPIN
                    );

                    let remaining = 0;
                    if (rsData.bonusInfo?.length && Number.isFinite(rsData.bonusInfo[0].respinsLeft)) {
                        remaining = rsData.bonusInfo[0].respinsLeft;
                    } else {
                        remaining = bonus.reSpinsCount - index - 1;
                    }

                    reSpin.reSpinData = {
                        awarded: bonus.reSpinsCount,
                        remaining: remaining,
                        win: rsData.creditsWon || 0,
                        reTriggered: 0,
                        reSpinsList: bonus.reSpinsList
                    }

                    if (reSpin.reSpinData.awarded < 0 || reSpin.reSpinData.remaining < 0) {
                        throw new Error("Negative respin counter detected!");
                    }

                    results.push(reSpin);
                    // Adding the respins, when in respin mode.
                    if (rsData?.bonusInfo?.length) {
                        rsData?.bonusInfo.forEach((bonusData) => {
                            this.addRespinData(
                                [bonusData],
                                result,
                                results,
                                isSpinFree
                            );
                        });
                    }
                });
            }
        });
    }

    parseSpinification(result: ISpinData): ISpinificationData {
        let spinification: ISpinificationData = {
            spinificationIndex: result.reelFinalSymbols.get(result.reelSetIndex).length,
            spinificationEndIndex: result.reelFinalSymbols.get(result.reelSetIndex).length,
        };
        let spinifyCount = new Map<number, number>();

        result.reelFinalSymbols.forEach((syms, reelSetIdx) => {
            syms.forEach((reel, reelId) => {
                reel.forEach((sym, rowId) => {
                    if (GameModel.gameConfig.spinifySymIds?.indexOf(sym) != -1) {
                        if (!spinifyCount.has(sym)) {
                            spinifyCount.set(sym, 0);
                        }
                        spinifyCount.set(sym, spinifyCount.get(sym) + 1);
                        if (
                            spinifyCount.get(sym) ===
                            GameModel.gameConfig.spinifyNumSymsNeeded[sym] &&
                            GameModel.gameConfig.spinifyReels.indexOf(reelId + 1) !=
                            -1
                        ) {
                            if (
                                !spinification.spinificationIndex ||
                                spinification.spinificationIndex > reelId + 1
                            ) {
                                spinification.spinificationIndex = reelId + 1;
                                spinification.spinificationSymbolId = sym;
                                spinification.spinificationEndIndex =
                                    GameModel.gameConfig.spinifyReels[
                                    GameModel.gameConfig.spinifyReels.length - 1
                                    ];
                            }
                        }
                    }
                });
            });
        });

        return spinification;
    }

    parseLine(line: IVendorLineData): IWinData {
        // @ts-ignore
        let numberOfReels = GameModel.serverGameConfig.reelToViewMap.length;
        let win: IWinData = {
            winSymbols: Array.from(
                new Array(line.matchPositions.length),
                (e, i) => {
                    return Math.floor(
                        (line.matchPositions[i] - 1) / numberOfReels
                    );
                }
            ),
            winReels: Array.from(
                new Array(line.matchPositions.length),
                (e, i) => {
                    return (line.matchPositions[i] - 1) % numberOfReels;
                }
            ),
            winSymId: line.symbol,
            isWay: !(
                GameModel.serverGameConfig?.paylines &&
                GameModel.serverGameConfig.paylines.length > 0
            ), //TODO
            lineId: line.line ? line.line - 1 : -1,
            normalLineWin: !!line.line,
            creditsWon: line.creditsWon,
        };

        win.coordinates = line.matchPositions.map((pos, index) => {
            return { x: win.winReels[index] + 1, y: win.winSymbols[index] + 1 };
        });

        return win;
    }

    parseWins(
        winData: IVendorWinData,
        bonusInfo: IVendorBonusData[]
    ): IWinData[] {
        let wins: IWinData[] = [];
        if (winData?.lines?.length) {
            winData.lines.forEach((line) => {
                wins.push(this.parseLine(line));
            });
        }
        if (bonusInfo?.length) {
            bonusInfo.forEach((bonus) => {
                if (bonus.matchPositions?.length) {
                    wins.push(this.parseLine(bonus));
                }
            });
        }
        return wins; // TODO
    }

    parseSlotObject(
        spinData: IVendorSpinData,
        isFree = false,
        mainSpinWin = 0,
        previousSpins?: ISpinData[],
        roundType?: RoundType | string
    ): ISpinData {
        let winsData = this.parseWins(
            spinData.winningLines,
            spinData.bonusInfo
        );

        const scatterWin = this.getScatterWin(spinData);
        const respinWin = this.getRespinWin(spinData);

        const winAmount = !isFree
            ? spinData.creditsWon - spinData.freeGameCreditsWon - respinWin
            : spinData.creditsWon - respinWin;

        const reelSetIndex: number = isFree ? 1 : 0;
        const stopPositions = new Map<number, number[]>();
        const reelFinalSymbols = new Map<number, number[][]>();
        const reelStopSymbols = new Map<number, number[][]>();

        stopPositions.set(reelSetIndex, spinData.reelStops);
        reelStopSymbols.set(reelSetIndex, spinData.view);
        reelFinalSymbols.set(reelSetIndex, spinData.finalView || spinData.view);

        let result: ISpinData = {
            winAmount,
            stopPositions,
            reelFinalSymbols,
            reelStopSymbols,
            winsData,
            reelSets: Utils.deepClone(GameModel.gameConfig.reelSets),
            reelSetIndex,
            isFree,
            roundType
        };

        this.accumulatedWin += winAmount;
        result.accumulatedWin = this.accumulatedWin;
        result.skatterWin = scatterWin;

        let spinification = this.parseSpinification(result);
        let overlays: IOverlayData[] = this.parseOverlays(
            result,
            spinData,
            previousSpins
        );

        return Object.assign({}, result, {
            spinification,
            overlays,
        });
    }

    cascadeHandle(
        spinData: IVendorSpinData,
        isFree = false,
        mainSpinWin = 0,
        previousSpins?: ISpinData[],
        roundType?: RoundType | string
    ): ISpinData {

        return null;
    }

    calculateWinOffset(winnings, symbols: any, isFree: boolean): any {
        debugger;
        if (winnings && winnings[0]) {
            let winOffset = [];
            winnings.forEach((winnig) => {
                winnig.winSymbols.forEach((row, index) => {
                    let reel = winnig.winReels[index];
                    let pos = row * App.config.numReels + reel;
                    let key: number = 0;
                    isFree ? key = 1 : key = 0;
                    if (!winOffset.includes(pos) && symbols.get(key)[reel][row] != 0) {
                        winOffset.push(row * App.config.numReels + reel);
                    }
                });
            });
            return winOffset;
        } else {
            return [];
        }
    }

    calculateRespinsOffset(respins: any[]): number[] {
        if (respins && respins.length > 0) {
            let respinOffsets = [];
            respins.forEach((r) => {
                let pos = r.y * (App.config.numVisibleLines + 1) + r.x;
                if (r.symbol === " " && !respinOffsets.includes(pos)) {
                    respinOffsets.push(pos);
                }
            });
            return respinOffsets;
        } else {
            return [];
        }
    }

    parseOverlays(
        result: ISpinData,
        spinData: IVendorSpinData,
        previousSpins?: ISpinData[]
    ): IOverlayData[] {
        return null;
    }
}
